import { render } from "./InquiryFormHomecareHomehealth.vue?vue&type=template&id=163158c4&ts=true"
import script from "./InquiryFormHomecareHomehealth.ts?vue&type=script&lang=ts&external"
export * from "./InquiryFormHomecareHomehealth.ts?vue&type=script&lang=ts&external"

import "../InquiryForm/InquiryForm.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__